import React, { useState, useEffect, useCallback } from "react";
import { Link, useParams, useLocation, matchPath } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import ReactPixel from "react-facebook-pixel";
import createPersistedState from "use-persisted-state";

import Logo from "../images/logo/owl-logo.svg";
import useCountdownRedirect from "../hooks/useCountdownRedirect";
import { verifyAccount } from "../api/actions/auth";
import { fetcher } from "../api/client";

import config from "../config";
import useQueryParams from "../hooks/useQuery";

const useAccountVerificationState = createPersistedState("accountVerified");

function AccountSuccess() {
    const { t } = useTranslation("common");
    const { code, username } = useParams();
    const [enableCountdown, setEnableCountdown] = useState(false);
    const [accountVerified, setAccountVerified] = useAccountVerificationState({verified:false});
    const verifyVersion = useQueryParams().get("version");
    const { mutate: mutateVerifyAccount } = useMutation((payload) => fetcher(verifyAccount(payload)), {
        onSuccess: () => {
            if (verifyVersion === "2") {
                console.log("2");
            } else setEnableCountdown(true);
        },
        onSettled: () => {
            setAccountVerified({verified:true});
        },
    });

    useEffect(() => {
        mutateVerifyAccount({
            username,
            code,
        });
    }, [code, username, mutateVerifyAccount]);

    useCountdownRedirect("/login", 5, enableCountdown);
    useEffect(() => {
        const advancedMatching = { em: code }; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching
        const options = {
            autoConfig: true, // set pixel's autoConfig
            debug: true, // enable logs
        };
        ReactPixel.init(config.fbPixels.register, advancedMatching, options);
        ReactPixel.pageView();
        ReactPixel.track("VerifyAccount", { code });
    }, [code]);


    return (
        <section id="signup" className="vh-100 d-flex">
            <div className="container align-self-center">
                <div className="card account-success align-self-center mx-auto w-50">
                    <div className="card-body text-center p-lg-5 p-3">
                        <img src={Logo} className="img-fluid w-25 mb-3" alt="Trato Logo" />
                        {verifyVersion !== "2" && (
                            <>
                                <h1 className="font-weight-bold">{t("successMessages.accountRegistered")}</h1>
                                <p
                                    className="lead text-muted mb-3"
                                    dangerouslySetInnerHTML={{
                                        __html: t("redirectToStarter"),
                                    }}
                                />
                                <Link to="/" className="btn btn-accent">
                                    {" "}
                                    {t("goToStarter")}{" "}
                                </Link>
                            </>
                        )}

                        {verifyVersion === "2" && (
                            <>
                                <h1 className="font-weight-bold">{t("successMessages.accountRegistered")}</h1>
                                <p className="lead text-muted mb-3">
                                    {t("actions.goToLogin")}
                                </p>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default AccountSuccess;
